import Component from './pagenation.vue';
export default Component;
